// INDEX.JS

import app from "./modules/app";
import formLabel from "./mixins/form-label";
import formValidation from "./mixins/form-validation";
import formValidationAjax from "./mixins/form-validation-ajax";
// import formAutocomplete from './mixins/form-autocomplete';
// import formAutocompleteMulti from './mixins/form-autocomplete-multi';
import formSaving from "./mixins/form-saving";
import formRestore from "./mixins/form-restore";
import helperHotjar from "./mixins/helper-hotjar";
import helperLightbox from "./mixins/helper-lightbox";
import helperMatomo from "./mixins/helper-matomo";
import helperModals from "./mixins/helper-modals";
import helperGoogle from "./mixins/helper-google";
import helperLazyload from "./mixins/helper-lazyload";
import helperObjectFit from "./mixins/helper-objectfit";
import inputFocusedPolyfill from "./mixins/input-focused-polyfill";
import additionalContent from "./elements/additional-content/additional-content";
import toggleContent from "./elements/toggle/toggle";
import popup from "./elements/popup/popup";
import messaging from "./elements/messaging/messaging";
import tableResponsiveUtils from "./mixins/table-responsive-utils";
import tableWrap from "./elements/tables/tables";
import searchInput from "./modules/search/search-in-page";
import searchResults from "./modules/search/search-results";
import flip from "./modules/flip/flip";
import contentBlock from "./modules/content-block/content-block";
import accordion from "./modules/accordion/accordion";
import tabstrip from "./elements/tabstrip/tabstrip";
import videoTrigger from "./elements/video-modal/video-modal";
import callMe from "./modules/call-me/call-me";
import megaMenu from "./modules/nav/mega-menu";
import navMobile2 from "./modules/nav/nav-mobile-2";
import navLevel from "./modules/nav/nav-level";
import videoFrame from "./modules/video/video";
import videoFrame2 from "./modules/video/video2";
import heroFull from "./modules/hero-full/hero-full";
import cardGridTopRow from "./modules/card-grid/card-grid-toprow";
import cardGridExpand from "./modules/card-grid/card-grid-expand";
import cardCarousel from "./modules/card-carousel/card-carousel";
import listFilter from "./modules/list-filter/list-filter";
import timeline from "./modules/timeline/timeline";
import timelineAdvanced from "./modules/timeline/timeline-advanced-2";
import timelineAdvancedBottomSection from "./modules/timeline/timeline-advanced-bottom-section";

// create a shared instance.
const instance = app();

helperLightbox(instance);
helperMatomo(instance);
helperGoogle(instance);
helperModals(instance);
helperHotjar(instance);

inputFocusedPolyfill(instance);

// register the shared modules
instance.registerModules([
    // helperCookieMessage,
    megaMenu,
    formLabel,
    formValidation,
    formValidationAjax,
    // formAutocomplete,
    // formAutocompleteMulti,
    tableResponsiveUtils,
    tableWrap,
    flip,
    additionalContent,
    toggleContent,
    // addressAutocomplete,
    // addressAutocompleteMultiAddress,
    helperLazyload,
    helperObjectFit,
    messaging,
    popup,
    // offCanvas,
    tabstrip,
    searchInput,
    searchResults,
    videoTrigger,
    callMe,
    // navMobile,
    navMobile2,
    navLevel,
    // navOffCanvas,
    videoFrame,
    videoFrame2,
    // heroSuperTheme,
    heroFull,
    cardGridTopRow,
    cardGridExpand,
    cardCarousel,
    contentBlock,
    accordion,
    listFilter,
    timeline,
    timelineAdvanced,
    timelineAdvancedBottomSection,
    formSaving,
    formRestore,
]);

// re-bootstrap - only for pattern guide
// the reason this is needed is because the style guide is
// rendered via angular, and doesn't exist in the page already so
// we need a manual handling here.
$(window).bind("styleguide:onRendered", function (e) {
    instance.bindModules();
});

export default instance;
